import { useEffect, useState } from 'react';
import { SessionFilter } from '../../../../hooks/use-session-filter';

const useCheckedLeasingOffers = (massDataLeasingOffersIds: string[], sessionFilter: SessionFilter) => {
  const [checkedLeasingOffers, setCheckedLeasingOffers] = useState<string[]>([]);

  useEffect(() => {
    setCheckedLeasingOffers([]);
  }, [sessionFilter.filterForServer]);

  const changeHeaderCheckboxHandler = (isChecked: boolean) => {
    if (isChecked) {
      setCheckedLeasingOffers(prevState => prevState.filter(item => !massDataLeasingOffersIds.includes(item)));
    } else {
      setCheckedLeasingOffers(prevState => [
        ...prevState.filter(item => !massDataLeasingOffersIds.includes(item)),
        ...massDataLeasingOffersIds
      ]);
    }
  };

  const changeRowCheckboxHandler = (id: string, checkboxState: { checked: boolean }) => {
    if (checkboxState.checked) {
      setCheckedLeasingOffers(prevState => prevState.filter(item => item !== id));
    } else {
      setCheckedLeasingOffers(prevState => [...prevState, id]);
    }
  };

  const clearCheckedLeasingOffers = () => {
    setCheckedLeasingOffers([]);
  };

  return { changeHeaderCheckboxHandler, changeRowCheckboxHandler, clearCheckedLeasingOffers, checkedLeasingOffers };
};

export default useCheckedLeasingOffers;
